var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81855 23.4622C4.51143 23.4622 0.833252 22.792 0.833252 20.1077C0.833252 17.4235 4.4881 14.9456 8.81855 14.9456C13.1257 14.9456 16.8039 17.3995 16.8039 20.0837C16.8039 22.7669 13.149 23.4622 8.81855 23.4622Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81017 11.2259C11.6367 11.2259 13.9276 8.93499 13.9276 6.10848C13.9276 3.28196 11.6367 0.98999 8.81017 0.98999C5.98365 0.98999 3.69168 3.28196 3.69168 6.10848C3.68213 8.92544 5.95713 11.2164 8.7741 11.2259C8.78683 11.2259 8.7985 11.2259 8.81017 11.2259Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/EditProfile.abc41b93dc2318ee25073a52791117fa.svg";
export { ForwardRef as ReactComponent };